import { type ButtonProps } from "@tokenterminal/core/ui/button/Button"
import { SelectField } from "@tokenterminal/core/ui/input/SelectField"

import { type Interval } from "@tokenterminal/tt-analytics-api-types/dist/api/zoom"
import { type GranularityType } from "@tokenterminal/ui/Chart/utils/groupDataBasedOnGranularity"

const getSupportedGranularitiesForInterval = (interval: Interval) => {
  if (interval === "24h") {
    return ["day"]
  } else if (interval === "7d") {
    return ["day", "week"]
  } else if (interval === "30d") {
    return ["day", "week", "month"]
  } else if (interval === "365d") {
    return ["day", "week", "month", "quarter"]
  } else if (interval === "max") {
    return ["week", "month", "quarter", "year"]
  }

  return ["day", "week", "month", "quarter"]
}

type Props = {
  selectedKey: GranularityType
  interval: Interval
  setGranularity: (granularity: GranularityType) => void
  buttonProps?: Partial<ButtonProps>
}

const GranularitySelectField = ({
  selectedKey,
  interval,
  setGranularity,
  buttonProps,
}: Props) => {
  return (
    <SelectField
      selectedKey={selectedKey}
      onSelectionChange={(value) => setGranularity(value as GranularityType)}
      aria-label="Grouped by"
      buttonProps={buttonProps}
    >
      <SelectField.Option
        id="day"
        isDisabled={
          !getSupportedGranularitiesForInterval(interval).includes("day")
        }
      >
        Daily
      </SelectField.Option>
      <SelectField.Option
        id="week"
        isDisabled={
          !getSupportedGranularitiesForInterval(interval).includes("week")
        }
      >
        Weekly
      </SelectField.Option>
      <SelectField.Option
        id="month"
        isDisabled={
          !getSupportedGranularitiesForInterval(interval).includes("month")
        }
      >
        Monthly
      </SelectField.Option>
      <SelectField.Option
        id="quarter"
        isDisabled={
          !getSupportedGranularitiesForInterval(interval).includes("quarter")
        }
      >
        Quarterly
      </SelectField.Option>
    </SelectField>
  )
}

export default GranularitySelectField
